/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import CreateUser from './components/CreateUser'
import TableUsers from './components/TableUsers'
import { Stack } from '@mui/material'
import useIsMounted from 'src/hooks/useIsMounted'
import { useAdminPermission } from 'src/hooks/IAM/AdminPermission/useAdminPermission'
import { useUserIAM } from 'src/hooks/IAM/AdminUser/useUserIAM'
import { useAdminGroup } from 'src/hooks/IAM/AdminGroups/useAdminGroups'
import { usePagination } from 'src/hooks/IAM/Components/Pagination/usePagination'

/**
 * Componente `AdminUser` que gestiona la administración de usuarios en la interfaz de usuario.
 * Este componente se encarga de cargar los grupos y permisos disponibles, así como la lista de usuarios.
 * 
 * @example
 * ```tsx
 * import AdminUser from './AdminUser';
 * 
 * const App = () => {
 *   return (
 *     <div>
 *       <AdminUser />
 *     </div>
 *   );
 * };
 * ```
 * 
 * @returns {JSX.Element} El componente JSX que renderiza la interfaz de administración de usuarios.
 */
const AdminUser = (): JSX.Element => {
  const { loadUsers } = useUserIAM()
  const isMounted = useIsMounted()
  const { loadPermissions } = useAdminPermission()
  const { loadGroups } = useAdminGroup()
  const { currentPage, rowsPerPage } = usePagination()

  useEffect(() => {
    if (!isMounted) return
    loadGroups({})
    loadPermissions({})
    loadUsers({
      currentPage,
      pageSize: rowsPerPage,
    })
  }, [isMounted])

  return (
    <Stack gap={4}>
      <CreateUser />
      <TableUsers />
    </Stack>
  )
}

export default AdminUser
